<template>
  <div class="msg-detail">
    <navigation sticky>消息详情</navigation>
    <!-- 确认书【仅退款时使用】 -->
    <section class="content" >
      <div v-if="content" v-html="content"></div>
    </section>
    <div class="footer" v-if="detail.verificationMode!=='NON'">
      <nd-button @click="handleVerifi" :disabled="$route.query.result === 'PASS'">我已阅读，并确认同意以上内容</nd-button>
      <auth :verificationMode="detail.verificationMode" ref="auth"></auth>
    </div>
  </div>
</template>

<script>

import Auth from './components/auth.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Auth
  },
  data () {
    return {
      detail: {},
      content: ''
    }
  },
 
  async mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messageDetail', 'messageRead']),
    handleVerifi () {
      this.$refs.auth.handleVerifi()
    },
    read () {
      this.messageRead({
        recordNo: this.$route.query.recordNo
      })
    },
    async getDetail () {
      const { success, data } = await this.messageDetail({
        recordNo: this.$route.query.recordNo
      })
      if (success && data) {
        this.detail = data
        this.content = data.content?.text
        if (this.detail.read === 'N') {
          this.read()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.msg-detail {
  height: 100vh;
 
  .content {
    padding: 20px;
    padding-bottom: 250px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    border-top: 20px solid #fafafa;
    font-size: 28px;

   /deep/ .title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
    }
    /deep/ .text {
      &.tr {text-align: right;}
      margin-top: 15px;
    }
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
.footer {
  display: flex;
  bottom: 0;
  height: 180px;
  background: #ffffff;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  position: fixed;
  bottom: 0;
  width: 10rem;
  justify-content: center;
  align-items: center;
}
</style>